function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { Button, Empty, Input, Tabs } from 'antd';
import React, { useContext, useState } from 'react';
import { ItemButton, MemberTree, RoleTree } from "./components/index";
import { RoleType } from "./constant";
import { PeopleRoleSelectContext } from "../../context";
import cx from 'classnames';
export var SelectRoleOrPerson = function SelectRoleOrPerson(_ref) {
  var groupNodes = _ref.groupNodes,
    setGroupNodes = _ref.setGroupNodes,
    memberNodes = _ref.memberNodes,
    setMemberNodes = _ref.setMemberNodes,
    value = _ref.value,
    _onChange = _ref.onChange,
    searchValue = _ref.searchValue,
    onChangeSearchValue = _ref.onChangeSearchValue,
    _ref$haveRightSide = _ref.haveRightSide,
    haveRightSide = _ref$haveRightSide === void 0 ? true : _ref$haveRightSide;
  var PeopleRoleSelectContextProps = useContext(PeopleRoleSelectContext);
  var mode = PeopleRoleSelectContextProps.mode,
    selectHeight = PeopleRoleSelectContextProps.selectHeight;
  var _useState = useState(RoleType.Role),
    _useState2 = _slicedToArray(_useState, 2),
    activeKey = _useState2[0],
    setActiveKey = _useState2[1];
  var onDelete = function onDelete(id) {
    setGroupNodes(groupNodes.filter(function (node) {
      return String(node.id) !== String(id);
    }));
    setMemberNodes(memberNodes.filter(function (node) {
      return String(node.id) !== String(id);
    }));
  };
  var items = [{
    key: RoleType.Role,
    label: '按角色',
    children: /*#__PURE__*/React.createElement("div", {
      className: 'content',
      style: {
        height: mode === 'select' ? selectHeight : 'auto'
      }
    }, /*#__PURE__*/React.createElement(RoleTree, {
      groupNodes: groupNodes,
      setGroupNodes: setGroupNodes,
      searchValue: searchValue
    }))
  }, {
    key: RoleType.Person,
    label: '按人员',
    children: /*#__PURE__*/React.createElement("div", {
      className: "content",
      style: {
        height: mode === 'select' ? selectHeight : 'auto'
      }
    }, /*#__PURE__*/React.createElement(MemberTree, {
      memberNodes: memberNodes,
      setMemberNodes: setMemberNodes,
      searchValue: searchValue
    }))
  }];
  return /*#__PURE__*/React.createElement("div", {
    className: "dr-people-role-select-modal"
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('frame', haveRightSide && 'in_modal')
  }, /*#__PURE__*/React.createElement("div", {
    className: 'tree'
  }, /*#__PURE__*/React.createElement(Tabs, {
    activeKey: activeKey,
    items: items,
    tabBarExtraContent: /*#__PURE__*/React.createElement(Input.Search, {
      placeholder: "\u641C\u7D22\u4EBA\u5458\u6216\u89D2\u8272",
      style: {
        width: 196
      },
      value: value,
      onSearch: function onSearch(tempValue) {
        onChangeSearchValue(tempValue);
      },
      onChange: function onChange(e) {
        return _onChange(e.target.value);
      }
    }),
    onChange: function onChange(key) {
      return setActiveKey(key);
    }
  })), haveRightSide && /*#__PURE__*/React.createElement("div", {
    className: 'selected'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'title'
  }, "\u5DF2\u9009 ", groupNodes.length + memberNodes.length, " \u9879", /*#__PURE__*/React.createElement(Button, {
    type: "link",
    onClick: function onClick() {
      setGroupNodes([]);
      setMemberNodes([]);
    }
  }, "\u6E05\u7A7A")), haveRightSide && /*#__PURE__*/React.createElement("div", {
    className: 'content'
  }, groupNodes.length + memberNodes.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, groupNodes.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, "\u89D2\u8272"), groupNodes.map(function (item) {
    return /*#__PURE__*/React.createElement(ItemButton, {
      key: item.id,
      name: item.completeName,
      id: item.id,
      onDelete: onDelete
    });
  })), memberNodes.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 16
    }
  }, "\u4EBA\u5458"), ' ', memberNodes.map(function (item) {
    return /*#__PURE__*/React.createElement(ItemButton, {
      key: item.id,
      name: item.completeName,
      id: item.id,
      onDelete: onDelete
    });
  }))) : /*#__PURE__*/React.createElement(Empty, {
    image: Empty.PRESENTED_IMAGE_SIMPLE,
    description: "\u8BF7\u5728\u5DE6\u4FA7\u9009\u62E9\u4EBA\u5458\u6216\u89D2\u8272",
    style: {
      marginTop: 80
    }
  })))));
};